<template>
  <div class="edit">
    <h2 class="tab-title">{{ $t("Approve the document") }}</h2>
    <button class="send-email-btn" @click="approve()" style="right: 70px; top: 100px;width: 110px;" v-if="!showSnackbar">
      <md-icon style="color: white">verified</md-icon> <span>Approve</span>
    </button>
    <button
      class="send-email-btn"
      @click="showRejectDialog=true"
      style="opacity: 0.85; right: 190px; top: 100px;"
      v-if="!showSnackbar"
    >
      <md-icon style="color: white">highlight_off</md-icon> <span>Reject</span>
    </button>

    <div row wrap style="display: flex; display: none">
      <div xs2>
        <button class="primary" block :disabled="noPrevPage" @click="prevPage">
          &#60;&#60;
        </button>
      </div>

      <div xs8 mt-3>{{ currentPage }} / {{ pageCount }}</div>

      <div xs2>
        <button class="primary" block :disabled="noNextPage" @click="nextPage">
          {{ ">>" }}
        </button>
      </div>
    </div>

    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Field properties</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <md-select
            v-model="recipient"
            name="email"
            id="email"
            placeholder="Recipient who fill"
          >
            <md-option
              v-for="email in emails"
              :value="JSON.stringify(email)"
              v-bind:key="email.email"
              :style="{
                'border-left': '6px solid',
                'border-color': email.color,
              }"
              >{{ email.email }}</md-option
            >
          </md-select>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="showDialog = false">Cancel</md-button>
        <md-button class="md-primary" @click="doAddField(newFieldType)"
          >Save</md-button
        >
      </md-dialog-actions>
    </md-dialog>







    <md-dialog :md-active.sync="showRejectDialog">
      <md-dialog-title>Reject transaction</md-dialog-title>
      <md-dialog-content>

     
      <md-field style="margin-top: 20px">
          <label>Comment</label>
          <md-textarea
            required
            placeholder="Please explain the reason to reject the transaction...*"
            v-model="rejectComment"
          ></md-textarea>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="rejectComment='';showRejectDialog = false">Cancel</md-button>
        <md-button :disabled="!rejectComment" class="md-primary" @click="reject()"
          >Save</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <div class="pdf-pagination" style="height: 45px">
      <div
        row
        wrap
        style="
          display: flex;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        "
      >
        <md-button
          class="md-icon-button md-raised"
          :disabled="noPrevPage"
          @click="prevPage"
        >
          <md-icon>navigate_before</md-icon>
        </md-button>
        <!-- <md-button class="md-raised">First</md-button> -->

        <div xs8 style="margin-top: 10px">
          {{ currentPage }} / {{ pageCount }}
        </div>

        <!-- <md-button class="md-raised">Last</md-button> -->
        <md-button
          class="md-icon-button md-raised"
          :disabled="noNextPage"
          @click="nextPage"
        >
          <md-icon>navigate_next</md-icon>
        </md-button>

        <div style="transform: translate(20px, -6px)">
          <md-button
            class="md-fab md-mini md-primary"
            style="box-shadow: none"
            @click="()=>{
let step = pageZoom%0.25 ==0?0.25:(pageZoom%0.25).toFixed(2);
 return pageZoom-step<0.25?pageZoom=0.25: pageZoom-= step;
            }"
            :disabled="pageZoom<=0.5"
          >
            <md-icon>zoom_out</md-icon>
          </md-button>
          <md-input type="number" step="25" min="50" max="200" style="width: 50px;
    text-align: right;
    margin-top: 17px;
    border: 1px solid #cec3c3;
    border-radius: 3px;" v-model="pageZoomAux" @blur.native="pageZoomValidate" @input.native="pageZoomInput" @keyup.enter="pageZoomValidate"></md-input>
         
          <md-button
            class="md-fab md-mini md-primary"
            style="box-shadow: none"
            :disabled="pageZoom>=2"
            @click="()=>{
let step = 0.25 - (pageZoom%0.25).toFixed(2);
 return pageZoom+step>2?pageZoom=2: pageZoom+= step;
 
            }"
          >
            <md-icon>zoom_in</md-icon>
          </md-button>
        </div>
      </div>
    </div>
    <div class="pdf-image-flieds-container" :style="'zoom:' + pageZoom">
      <div style="position: relative">
        <div>
          <img
            id="pdf-image"
            :src="pages[currentPage - 1]"
            alt=""
            :onload="onLoadImg()"
            style="position: absolute; left: 50%; transform: translateX(-50%)"
          />
        </div>
      </div>
      <div style="position: relative; width: 100%">
        <div style="position: absolute; left: 50%; transform: translateX(-50%)">
          <div id="fields-cont" style="position: relative">
            <component
              v-for="field in fields"
              :style="
                shownFields.indexOf(field) == -1
                  ? 'display:none!important;'
                  : ''
              "
              :is="field"
              :key="field.tmpId"
              :ref="field.tmpId"
            ></component>
          </div>
        </div>
      </div>
    </div>

    <md-speed-dial
      class="md-bottom-right email-legend"
      md-event="click"
      style="align-items: flex-end; position: fixed; z-index: 2"
    >
      <md-speed-dial-target>
        <md-icon>email</md-icon>
      </md-speed-dial-target>

      <md-speed-dial-content style="align-items: flex-end">
        <md-button
          v-for="(color, email) in recipientColors"
          :key="email"
          disabled
          style="background: none !important"
        >
          <div style="display: flex">
            <div
              :style="{
                'text-transform': 'none',
                color: 'rgba(0,0,0,.7)',
                'margin-right': '5px',
                background: 'white',
                padding: '5px 10px',
                'border-radius': '5px',
                'box-shadow': 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
              }"
            >
              {{ findRecipientName(email) + " (" + email + ")" }}
            </div>
            <div
              :style="{
                background: color,
                'border-radius': '50%',
                display: 'inline-block',
                height: '20px',
                width: '20px',
                'margin-right': '10px',
                'margin-top': '5px',
              }"
            ></div>
          </div>
        </md-button>
      </md-speed-dial-content>
    </md-speed-dial>

    <!-- <div style="position:fixed; left: 20px;    bottom: 20px;">
<md-button
            class="md-fab md-mini md-primary "
            
            @click="pageZoom+=0.25;"
          >
            <md-icon>zoom_in</md-icon>
          </md-button>

          <md-button
            class="md-fab md-mini md-primary "
            @click="pageZoom-=0.25;"
          >
            <md-icon>zoom_out</md-icon>
          </md-button>
</div> -->

    <md-snackbar
      md-position="center"
      :md-duration="9000"
      :md-active.sync="showSnackbar"
      md-persistent
      style="bottom: 45px"
    >
      <span>Cannot approve! Each user can approve once.</span>
    </md-snackbar>


    <md-dialog :md-active.sync="showErrorAuth">
      <md-dialog-title
        >Please authenticate</md-dialog-title
      >
      <md-dialog-content>
        <p>Unauthorized. Please login and open the link again.</p>
      </md-dialog-content>
      <md-dialog-actions>

        <md-button
          class="md-primary"
          @click="
            $router.push({
              path: 'login',
            });
            showDoneDialog = false;
          "
          >LOGIN</md-button
        >
      </md-dialog-actions>
    </md-dialog>




  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import moment from "moment";
import pdf from "vue-pdf";
import VueDragResize from "vue-drag-resize";
import DragResizeField from "@/components/DragResizeField.vue";
import SignField from "@/components/SignField.vue";
import DynamicField from "@/components/DynamicField.vue";
// var initDocHeight;
export default {
  name: "Approve",
  components: {
    pdf,
    VueDragResize,
    DragResizeField,
    SignField,
    DynamicField,
  },
  async mounted() {
    var vm = this;
    const trailResponse= await axios({
      method: "get",
      url: "/trail/record",
      baseURL: process.env.VUE_APP_BASE_API,
      headers: {
        ref: vm.$route.query.ref,
        Authorization: "Bearer " + Vue.prototype.$userData.tokens.access.token,
      },
      params: {
        transactionId: vm.$route.query.transactionId,
      },
    });
    vm.trail =trailResponse&&trailResponse.data? trailResponse.data
          .map((record) => {
            record.date = moment(record.date).format(
              this.dateTimeFormat  );
            return record;
          }):[];
    





    axios({
      method: "get",
      url: "/sign/transaction",
      baseURL: process.env.VUE_APP_BASE_API,
      headers: {
        Authorization: "Bearer " + Vue.prototype.$userData.tokens.access.token,
      },
      params: {
        transactionId: vm.$route.query.transactionId,
      },
    })
      .then((response) => {
        console.log("SUCCESS trn!!");
        console.log(response);
        vm.transactionData = response.data;
        vm.sign_document = response.data.sign_document;

        if (
          vm.transactionData.signStatus != 2 &&
          vm.transactionData.signStatus != 5
        ) {
          vm.showSnackbar = true;
          return;
        } else {
          let currentUserEmail = vm.$route.query.email || Vue.prototype.$userData.user.email ;

          if (vm.transactionData.signStatus == 2) {
            if (
              !vm.transactionData.processed.initial.some(function (ele) {
                return ele.mail === currentUserEmail && !ele.finished;
              })
            ) {
              vm.showSnackbar = true;
              return;
            }
          } else if (vm.transactionData.signStatus == 5) {
            if (
              !vm.transactionData.processed.final.some(function (ele) {
                return ele.mail === currentUserEmail && !ele.finished;
              })
            ) {
              vm.showSnackbar = true;
              return;
            }
          }
        }

        for (let i = 0; i < vm.transactionData.recipients.length; i++) {
          vm.recipientColors[vm.transactionData.recipients[i]] =
            vm.colors.shift();
        }
        setTimeout(function () {
          document.querySelector(".email-legend .md-speed-dial-target").click();
        }, 0);

        for (let index = 0; index < vm.transactionData.fields.length; index++) {
          const field = vm.transactionData.fields[index];


const recorodTrail = vm.trail.find((e)=>{return e.type=='SIGN'&&((e.user ||'').toLowerCase().indexOf((field.owner||'').toLowerCase())>-1);})
if(recorodTrail){
  field.ip=recorodTrail.ip || '';
  field.date=recorodTrail.date || '';

}
          vm.doAddField(field);
        }

        axios({
          method: "post",
          url: "/sign/getDocument",
          baseURL: process.env.VUE_APP_BASE_API,
          headers: {
            Authorization:
              "Bearer " + Vue.prototype.$userData.tokens.access.token,
          },
          data: {
            docId: vm.sign_document,
          },
        })
          .then((response) => {
            console.log(" docSUCCESS!!");
            console.log(response);
            vm.currentPageImg = response.data.pages[0];
            vm.pages = response.data.pages;
            vm.pageCount = vm.pages.length;
          })
          .catch(function () {
            console.log(" doc FAILURE!!");
          });
      })
      .catch(function () {
        console.log("FAILURE!!");
        vm.showErrorAuth=true;
      });

    this.emails = JSON.parse(localStorage.getItem("recipients"));
    console.log(this.emails);

    window.initDocHeight = document.querySelector("#pdf-image").offsetHeight;
    window.initDocWidth = document.querySelector("#pdf-image").offsetWidth;

    function reportWindowSize() {
      var imgPdf = document.getElementById("pdf-image");
      var fieldsCont = document.getElementById("fields-cont");
      fieldsCont.style.height = imgPdf.offsetHeight + "px";
      fieldsCont.style.width = imgPdf.width + "px";

      var newDocHeight = document.querySelector("#pdf-image").offsetHeight;
      var newDocWidth = document.querySelector("#pdf-image").offsetWidth;
      var zoom;

      if (window.initDocWidth < newDocWidth) {
        zoom = newDocHeight / window.initDocHeight;

        if (zoom * window.initDocWidth > newDocWidth) {
          zoom = newDocWidth / window.initDocWidth;
        }
      } else {
        zoom = newDocWidth / window.initDocWidth;

        if (zoom * window.initDocHeight > newDocHeight) {
          zoom = newDocHeight / window.initDocHeight;
        }
      }

      // var scale= newDocHeight / window.initDocHeight;
      document.getElementById("fields-cont").style.zoom = zoom * 0.95;
      console.log(newDocHeight);
      // window.initDocHeigh=newDocHeight;
    }

    window.onresize = reportWindowSize;
  },
  data() {
    return this.initialData();
  },
  computed: {
    noPrevPage() {
      return this.currentPage <= 1;
    },
    noNextPage() {
      return this.currentPage === this.pageCount;
    },
  },
  watch: {
    pageZoom: function (newVal) {
      this.pageZoomAux=Math.round(newVal*100);

     
    },
  },
  methods: {
    pageZoomInput(event){
            if (!event.inputType||event.inputType === "increment" || event.inputType === "decrement") {
  this.pageZoomValidate();
}
    },
    pageZoomValidate() {
      const vm =this;
let validZoom= false;
const newVal=vm.pageZoomAux/100;
if(newVal>2){
      vm.pageZoom=2;
     }else  if(newVal<0.25){
      vm.pageZoom=0.25;
     }else{
      validZoom= true;
      vm.pageZoom=Number(newVal);
     }

     if(!validZoom){
      Vue.$toast.open({
              message: "The zoom value must be between 25% and 200%",
              position: "bottom",
              type: "default",
            });
     }
     
    },
    initialData() {
      return {
        dateFormat: localStorage.getItem("generalConfiguration") ? JSON.parse(localStorage.getItem("generalConfiguration"))["dateFormat"] : "dd.MM.yyyy",
      dateTimeFormat: localStorage.getItem("generalConfiguration") ? JSON.parse(localStorage.getItem("generalConfiguration"))["dateTimeFormat"] : "dd.MM.yyyy",
        trail:[],
        pageZoom: 1,
        showErrorAuth:false,
        pageZoomAux: 100,
        colors: [
          "#7CB9E8",
          "#9966CC",
          "#E52B50",
          "#F19CBB",
          "#3B7A57",
          "#FFBF00",
          "#FF7E00",
          "#841B2D",
          "#008000",
          "#007FFF",
          "#87421F",
        ],
        recipientColors: {},
        showSnackbar: false,
        pages: [],
        currentPageImg: null,
        transactionData: {},
        sign_document: "",
        currentPage: 1,
        pageCount: 0,
        src: null,
        zoom: 100,
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        fields: [],
        shownFields: [],
        emails: [],
        showDialog: false,
        showRejectDialog: false,
        rejectComment: "",
        newFieldType: "",
        recipient: "",
      };
    },
    findRecipientName(email) {
      var data = this.transactionData.names.find((el) => {
        return el.email == email;
      });
      return data.name;
    },
    download() {
      const vm = this;

      axios({
        method: "post",
        url: "/sign/download",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: {
          docId: vm.sign_document,
        },
      })
        .then((response) => {
          console.log(" downSUCCESS!!");
          console.log(response);
        })
        .catch(function () {
          console.log(" down FAILURE!!");
        });
    },
    reject() {
      var vm = this;
      delete vm.transactionData.id;
      axios({
        method: "put",
        url: "/sign/reject",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data:{
comment:vm.rejectComment
        },
        params: {
          transactionId: vm.$route.query.transactionId,
        },
      })
        .then(() => {
          console.log("SUCCESS!!");

          vm.$router.push({
            path: "trail",
            query: { transactionId: vm.$route.query.transactionId },
          });
        })
        .catch(function () {
          console.log("FAILURE!!");
          vm.showSnackbar = true;
        });
    },
    approve() {
      var vm = this;
      delete vm.transactionData.id;
      axios({
        method: "post",
        url: "/sign/release",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        params: {
          transactionId: vm.$route.query.transactionId,
        },
      })
        .then(() => {
          console.log("SUCCESS!!");

          vm.$router.push({
            path: "trail",
            query: { transactionId: vm.$route.query.transactionId },
          });
        })
        .catch(function () {
          console.log("FAILURE!!");
          vm.showSnackbar = true;
        });
    },
    onLoadImg() {
      setTimeout(function () {
        var imgPdf = document.getElementById("pdf-image");
        var fieldsCont = document.getElementById("fields-cont");
        fieldsCont.style.height = imgPdf.offsetHeight + "px";
        fieldsCont.style.width = imgPdf.width + "px";
      }, 0);
    },

    prevPage() {
      this.currentPage--;
      this.updateFields();
    },
    nextPage() {
      this.currentPage++;
      this.updateFields();
    },
    resize(newRect) {
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    pageLoaded(event) {
      this.currentPage = event;
      window.initDocHeight = document.querySelector("#pdf-viewer").offsetHeight;
      console.log("pageloaded");
      console.log(window.initDocHeight);
    },
    addField(type) {
      this.showDialog = true;
      this.newFieldType = type;
    },
    doAddField(field) {
      var vm = this;
      var fields = vm.fields;

      delete field._id;
      fields.push({
        render(h) {
          return h(DynamicField, {
            class: ["foo"],
            template: "<span>holi</span>",
            on: {
              change: function (val) {
                field.image = val || undefined;
              },
            },
            props: {
              value: field.image || null,
              top: field.top,
              left: field.left,
              width: field.width,
              height: field.height,
              owner: field.owner,
              ip: field.ip || '',
              date: field.date || '',
                     required: field.required,
              name: vm.findRecipientName(field.owner),
              color: vm.recipientColors[field.owner],
              disabled: true,
              hideMark:true,
              type: (field.image?'sign':(field.type || "date")),
              index: fields.length - 1,
            },
          });
        },
      });
      fields[fields.length - 1].page = field.page;
      console.log(fields);
      this.updateFields();
    },
    updateFields() {
      var vm = this;

      this.shownFields = this.fields.filter(function (el) {
        return el.page == vm.currentPage;
      });
    },
  },
  beforeDestroy() {
    Object.assign(this.$data, this.initialData());
  },
};
</script>

<style scoped>
.tab-title {
  color: #a5a5a5;
  margin-bottom: 30px;
}
.edit {
  margin: 10px;
}

.send-email-btn {
  margin: 0;
  padding: 0;
  display: inline-block;
  position: relative;
  overflow: hidden;
  outline: none;
  background: transparent;
  border: 0;
  border-radius: 0;
  transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: inherit;
  line-height: normal;
  text-decoration: none;
  vertical-align: top;
  white-space: nowrap;
  min-width: 88px;
  height: 36px;
  margin: 6px 8px;
  -webkit-user-select: none;
  user-select: none;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  top: 45px;
  right: 30px;
  cursor: pointer;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
  color: #fff;
  color: var(--md-theme-default-text-primary-on-primary, #fff);
  background-color: #e94e1b;
  background-color: var(--md-theme-default-primary, #e94e1b);
  position: absolute;
}
.send-email-btn a {
  color: white !important;
  font-weight: bold !important;
}

.md-button-content .md-checkbox {
  width: 150px;
}

.md-button-content input {
  width: 130px;
}

label,
.md-checkbox-label {
  text-transform: none !important;
}
.send-email-btn {
  margin: 0;
  padding: 0;
  display: inline-block;
  position: relative;
  overflow: hidden;
  outline: none;
  background: transparent;
  border: 0;
  border-radius: 0;
  transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: inherit;
  line-height: normal;
  text-decoration: none;
  vertical-align: top;
  white-space: nowrap;
  min-width: 100px;
  height: 36px;
  margin: 6px 8px;
  -webkit-user-select: none;
  user-select: none;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  top: 45px;
  right: 30px;
  cursor: pointer;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
  color: #fff;
  color: var(--md-theme-default-text-primary-on-primary, #fff);
  background-color: #e94e1b;
  /* background-color: var(--md-theme-default-primary, #e94e1b); */
  position: absolute;
}
.send-email-btn a,
.send-email-btn span {
  color: white !important;
  font-weight: bold !important;
}

.send-email-btn:disabled {
  background: #dddddd;
  box-shadow: none;
  cursor: default;
}

.email-legend button {
  background: white !important;
}

.email-legend button i {
  color: rgba(0, 0, 0, 0.54) !important;
}
</style>